import React, { useState, useEffect, useRef } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../Assets/dshbrdlogo.png';
import icon from '../../../Assets/dshbrdicon.png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../Assets/cardtrsnct.png';
import trsanstinactive from '../../../Assets/trnsactn-active.png';
import acctn from '../../../Assets/Accountingicon.png';
import acctnactive from '../../../Assets/Accountingicon-active.png';
import rprts from '../../../Assets/reportsicon.png';
import rprtsactive from '../../../Assets/reportsicon-active.png';
import bnkn from '../../../Assets/bankin-icon.png';
import bnknactive from '../../../Assets/bankin-icon-active.png';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/settings-icon-active.png';
import usrnoti from '../../../Assets/notificatuin-bell.png';
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { useUser } from '../../../UserContext';
import Balance from "../../../Pages/Balance/Balance";

import ChangePassword from "../../../Pages/ChangePassword/ChangePassword";
import UploadSalaryModal from '../../../Components/Modals/UploadSalaryModal';
import UploadAllowanceModal from '../../../Components/Modals/UploadAllowanceModal';
import InviteUserModal from "../../../Components/Modals/InviteUserModal";
export default function HeaderNav() {
  const location = useLocation();
  const { user, logout, updateUser, setActiveCompany } = useUser();
  const navigate = useNavigate();
  const [companyList, setCompanyList] = useState([]);
  const [companySwitcherOpen, setCompanySwitcherOpen] = useState(false);
  const companySwitcherCloseTimerRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const userDropdownRef = useRef(null);
  const [isBalanceOpen, setIsBalanceOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showUploadAllowanceModal, setShowUploadAllowanceModal] = useState(false);
  const [showInviteUserModal, setShowInviteUserModal] = useState(false);
  const baseNavItems = [
    { label: 'Home', path: '/dashboard', icon: iconinactive, activeIcon: icon },
    { label: 'Setup', path: '/settings', icon: stngs, activeIcon: stngsactive },
    { label: 'Transactions', path: '/transactions', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Accounting', path: '/accounts', icon: acctn, activeIcon: acctnactive },
    { label: 'Fixed Assets', path: '/fixed-assets', icon: bnkn, activeIcon: bnknactive },
    { label: 'Payroll', path: '/payroll', icon: rprts, activeIcon: rprtsactive },
    { label: 'Inventory', path: '/inventory', icon: acctn, activeIcon: acctnactive },
    { label: 'Reports', path: '/report', icon: rprts, activeIcon: rprtsactive },
  ];

  // Add Admin item only for super admin, positioned between Home and Setup
  const navItems = user?.email === "admin@brookes.com" 
    ? [baseNavItems[0], { label: 'Admin', path: '/admin', icon: stngs, activeIcon: stngsactive }, ...baseNavItems.slice(1)]
    : baseNavItems;

  // Close dropdowns when clicking outside
  useEffect(() => {
    // load companies from localStorage so header can offer quick switching
    try {
      const raw = localStorage.getItem('companies');
      if (raw) setCompanyList(JSON.parse(raw));
    } catch (e) { console.error('Failed to parse companies from localStorage', e); }

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
      if (userDropdownRef.current && !userDropdownRef.current.contains(e.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (companySwitcherCloseTimerRef.current) {
        clearTimeout(companySwitcherCloseTimerRef.current);
        companySwitcherCloseTimerRef.current = null;
      }
    };
  }, []);

  const openCompanySwitcher = () => {
    if (companySwitcherCloseTimerRef.current) {
      clearTimeout(companySwitcherCloseTimerRef.current);
      companySwitcherCloseTimerRef.current = null;
    }
    setCompanySwitcherOpen(true);
  };

  const scheduleCloseCompanySwitcher = () => {
    if (companySwitcherCloseTimerRef.current) {
      clearTimeout(companySwitcherCloseTimerRef.current);
    }
    // Small delay prevents closing when moving cursor to submenu
    companySwitcherCloseTimerRef.current = setTimeout(() => {
      setCompanySwitcherOpen(false);
      companySwitcherCloseTimerRef.current = null;
    }, 180);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };


  return (
    <div className={classes.entnav22}>
      <NavLink to="/dashboard">  <img src={logo} alt="Logo" className={classes.logo} /></NavLink>

      <div className={classes.headerNav}>
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          const isDropdown = item.label === 'Transactions' || item.label === 'Setup' || item.label === 'Admin' || item.label === 'Fixed Assets' || item.label === 'Inventory' || item.label === 'Accounting' || item.label === 'Payroll' || item.label === 'Reports';

          return isDropdown ? (
            <div
              key={item.label}
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
            >
              {/* Dropdown toggle area */}
              <div
                className={classes.dshbrdnavMain}
                onClick={() =>
                  setOpenDropdown(openDropdown === item.label ? null : item.label)
                }
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>

              {/* Dropdown content */}
              {openDropdown === item.label && (
                <div className={classes.dropdown} ref={dropdownRef}>

                  {item.label === 'Transactions' && (
                    <>

                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Receivables</span>
                        <div className={classes.submenu}>
                          {/* <NavLink to="/transactions/sales-invoice/sale" onClick={() => setOpenDropdown(null)}>
                            Sales
                          </NavLink> */}
                          <NavLink to="/transactions/receivables/customers" onClick={() => setOpenDropdown(null)}>
                            Customers
                          </NavLink>
                          <NavLink to="/transactions/receivables/customer-sales" onClick={() => setOpenDropdown(null)}>
                            Customer Sales
                          </NavLink>

                          <NavLink to="/transactions/receivables/sales" onClick={() => setOpenDropdown(null)}>
                            Sales Invoice
                          </NavLink>
                          <NavLink to="/transactions/sales-invoice/receivables" onClick={() => setOpenDropdown(null)}>
                            Receivables
                          </NavLink>




                        </div>
                      </div>


                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Payables</span>
                        <div className={classes.submenu}>
                          <NavLink to="/transactions/payables/suppliers" onClick={() => setOpenDropdown(null)}>
                            Supplier's Details
                          </NavLink>
                          <NavLink to="/transactions/payables/purchase" onClick={() => setOpenDropdown(null)}>
                            Purchase Invoice
                          </NavLink>
                          <NavLink to="/transactions/paye-payable" onClick={() => setOpenDropdown(null)}>
                            PAYE Payable
                          </NavLink>
                          <NavLink to="/transactions/pension-payable" onClick={() => setOpenDropdown(null)}>
                            Pension Payable
                          </NavLink>
                          <NavLink to="/transactions/vat-payable" onClick={() => setOpenDropdown(null)}>
                            Value Added Tax Payable
                          </NavLink>
                          <NavLink to="/transactions/witholding-tax-payable" onClick={() => setOpenDropdown(null)}>
                            Witholding Tax Payable
                          </NavLink>
                          <NavLink to="/transactions/payables/supplier-ledger" onClick={() => setOpenDropdown(null)}>
                            Individual Supplier's Ledger
                          </NavLink>
                          {/* <NavLink to="/transactions/payables/payables" onClick={() => setOpenDropdown(null)}>
                           Payables
                          </NavLink> */}
                        </div>
                      </div>
                      {/* <NavLink
                        to="/transactions/purchase-invoice/suppliers"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Suppliers
                      </NavLink> */}
                      {/* <NavLink
                        to="/transactions/payables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payables
                      </NavLink> */}
                      <NavLink
                        to="/transactions/pettycash"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Petty Cash
                      </NavLink>
                      <NavLink
                        to="/transactions/lodgement"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Lodgement
                      </NavLink>

                      <NavLink
                        to="/transactions/sales-pos"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Sales (POS)
                      </NavLink>

                      {/* <NavLink
                        to="/transactions/receipts"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Receipt
                      </NavLink> */}
                      {/* <NavLink
                        to="/transactions/payment"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payment
                      </NavLink> */}
                      <NavLink
                        to="/transactions/bank-payments"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payment
                      </NavLink>
                      <NavLink
                        to="/transactions/paye-payments"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Tax Remittances
                      </NavLink>

                      {/* <NavLink
                        to="/transactions/loan-payments"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Loan and Advances
                      </NavLink> */}

                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Loan and Advances</span>
                        <div className={classes.submenu}>

                          <NavLink to="/transactions/loan-payments" onClick={() => setOpenDropdown(null)}>
                            Loan and Advances
                          </NavLink>
                          <NavLink to="/transactions/loan-allocated" onClick={() => setOpenDropdown(null)}>
                            Staff Personal Ledger
                          </NavLink>

                          {/* <NavLink to="/transactions/receivables/sales" onClick={() => setOpenDropdown(null)}>
                            Sales Invoice
                          </NavLink>
                          <NavLink to="/transactions/sales-invoice/receivables" onClick={() => setOpenDropdown(null)}>
                            Receivables
                          </NavLink> */}




                        </div>
                      </div>

                      <NavLink
                        to="/transactions/cashReciept"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Receipt
                      </NavLink>

                    </>
                  )}

                  {user?.email === "admin@brookes.com" && item.label === 'Admin' && (
                    <>
                      <NavLink
                        to="/admin/product-services"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Companies
                      </NavLink>
                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Users
                      </NavLink>




                      <NavLink
                        to="/admin/manage-industry"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Chart of Account
                      </NavLink>



                      
                    </>
                  )}

                  {item.label === 'Setup' && (
                    <>
                      <NavLink
                        to="/settings/product-services"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Products & Services
                      </NavLink>
                      {/* <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Purchase Sales
                      </NavLink> */}
                      <NavLink
                        to="/settings/manage-user"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage User
                      </NavLink>

                      <NavLink
                        to="/settings/manage-loans"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Loans
                      </NavLink>
                      <NavLink
                        to="/settings/manage-department"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Department
                      </NavLink>
                      <NavLink
                        to="/settings/manage-role"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Role
                      </NavLink>
                      <NavLink
                        to="/settings/manage-store"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Store
                      </NavLink>

                      {user?.email === "admin@brookes.com" && (
                        <NavLink
                          to="/settings/manage-industry"
                          onClick={() => setOpenDropdown(null)}
                          className={({ isActive }) =>
                            `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                          }
                        >
                          Manage Industry
                        </NavLink>
                      )}

                      <NavLink
                        to="/settings/manage-location"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Location
                      </NavLink>
                      <NavLink
                        to="/settings/manage-currency"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Currency
                      </NavLink>
                    </>
                  )}



                  {item.label === 'Fixed Assets' && (
                    <>
                      {/* <NavLink
                        to="/banking/pettycash"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Petty Cash
                      </NavLink>
                      <NavLink
                        to="/banking/lodgement"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Lodgement
                      </NavLink> */}
                      <NavLink
                        to="/fixed_assets/assetcategory"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Category
                      </NavLink>
                      <NavLink
                        to="/fixed_assets/fixedasset"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Fixed Asset
                      </NavLink>
                      <NavLink
                        to="/fixed_assets/assetlocation"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Location
                      </NavLink>
                      <NavLink
                        to="/fixed_assets/assetassignment"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Assignment
                      </NavLink>
                      {/* <NavLink
                        to="/fixed_assets/assetdepreciation"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Asset Depreciation
                      </NavLink> */}
                      <NavLink
                        to="/fixed_assets/assetrevaluation"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Revaluation
                      </NavLink>
                      <NavLink
                        to="/fixed_assets/assetdisposal"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Disposal
                      </NavLink>
                      <NavLink
                        to="/fixed_assets/assetmaintainance"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        {/* Payment */} Asset Maintainance
                      </NavLink>
                      <NavLink
                        to="/fixed-assets/assetmovement"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Asset Movement
                      </NavLink>
                      <NavLink
                        to="/fixed-assets/assetdocuments"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Asset Documents
                      </NavLink>
                    </>
                  )}
                  {item.label === 'Payroll' && (
                    <>
                      <NavLink
                        to="/payroll/setup-allowance"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Setup Allowances
                      </NavLink>

                      <NavLink
                        to="/payroll/setup-deduction"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Manage Deductions
                      </NavLink>
                      <NavLink
                        to="/payroll/monthly-deduction"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Monthly Deductions
                      </NavLink>
                      <NavLink
                        to="/payroll/employee-record"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Employees' Record
                      </NavLink>
                      <NavLink
                        to="/payroll/salary-structure"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Salary Structure Setup
                      </NavLink>
                      {user?.company?.payroll_computation_method !== "2" && (
                        <>
                          <NavLink
                            to="/payroll/upload-basic-salary"
                            onClick={() => setOpenDropdown(null)}
                            className={({ isActive }) =>
                              `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                            }
                          >
                            Upload Basic Salary
                          </NavLink>

                          <div
                            role="button"
                            tabIndex={0}
                            onClick={() => { setOpenDropdown(null); setShowUploadAllowanceModal(true); }}
                            className={classes.dropdownItem}
                            style={{ cursor: 'pointer' }}
                          >
                            Upload Allowance
                          </div>
                        </>
                      )}

                      <NavLink
                        to="/payroll/monthly-salary-competition"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Monthly Salary Computation
                      </NavLink>

                      {/* <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Cash Management</span>
                        <div className={classes.submenu}>
                           <NavLink to="/transactions/sales-invoice/sale" onClick={() => setOpenDropdown(null)}>
                            Sales
                          </NavLink> 
                          <NavLink to="/banking/cashmanage/cashReciept" onClick={() => setOpenDropdown(null)}>
                            Cash Reciept
                          </NavLink>


                        </div>
                      </div>*/}
                    </>
                  )}

                  {item.label === 'Inventory' && (
                    <>
                      <NavLink
                        to="/inventory/purchaseOrder"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Purchase Order
                      </NavLink>
                      <NavLink
                        to="/inventory/StockRequisition"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Stock Requisition
                      </NavLink>
                      <NavLink
                        to="/inventory/stocks_delivery"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Stocks Delivery
                      </NavLink>
                      <NavLink
                        to="/inventory/stocks_received"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Stocks Received
                      </NavLink>
                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Work-in-Progress</span>
                        <div className={classes.submenu}>
                          {/* <NavLink to="/transactions/sales-invoice/sale" onClick={() => setOpenDropdown(null)}>
                            Sales
                          </NavLink> */}
                          <NavLink to="/inventory/workProgress/createOrder" onClick={() => setOpenDropdown(null)}>
                            Create Production Order
                          </NavLink>
                          <NavLink to="/inventory/workProgress/rawMaterial" onClick={() => setOpenDropdown(null)}>
                            Raw Material Requisition Form
                          </NavLink>
                          {/* <NavLink to="/inventory/workProgress/materialsending" onClick={() => setOpenDropdown(null)}>
                            Raw Materials Issuance
                          </NavLink> */}
                          <NavLink to="/inventory/workProgress/finishedGoods" onClick={() => setOpenDropdown(null)}>
                            Transfer to Finished Goods
                          </NavLink>

                          <NavLink to="/inventory/workProgress/workSummary" onClick={() => setOpenDropdown(null)}>
                            Work in Progress Summary
                          </NavLink>


                        </div>
                      </div>
                      {/* <NavLink
                        to="/inventory/supplier_payables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payables
                      </NavLink> */}

                    </>
                  )}
                  {item.label === 'Reports' && (
                    <>
                      <NavLink
                        to="/report/financial-statements"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Financial Statements
                      </NavLink>
                      <NavLink
                        to="/reports/wht-payment"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Witholding Tax Payment
                      </NavLink>
                      <NavLink
                        to="/reports/payslip"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payslip
                      </NavLink>
                      {/* <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Work-in-Progress</span>
                        <div className={classes.submenu}>
                         
                          <NavLink to="/inventory/workProgress/rawMaterial" onClick={() => setOpenDropdown(null)}>
                            Raw Material Requisition Form
                          </NavLink>
                          <NavLink to="/inventory/workProgress/createOrder" onClick={() => setOpenDropdown(null)}>
                            Create Production Order
                          </NavLink>
                          <NavLink to="/inventory/workProgress/materialsending" onClick={() => setOpenDropdown(null)}>
                            Raw Materials Sending
                          </NavLink>
                          <NavLink to="/inventory/workProgress/finishedGoods" onClick={() => setOpenDropdown(null)}>
                            Transfer to Finished Goods
                          </NavLink>

                          <NavLink to="/inventory/workProgress/workSummary" onClick={() => setOpenDropdown(null)}>
                            Work in Progress Summary
                          </NavLink>


                        </div>
                      </div> */}
                      {/* <NavLink
                        to="/inventory/supplier_payables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payables
                      </NavLink> */}

                    </>
                  )}

                  {item.label === 'Accounting' && (
                    <>
                      <NavLink
                        to="/reports/charting"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Charts of Accounts
                      </NavLink>
                      <span
                        onClick={() => {
                          setOpenDropdown(null);
                          setIsBalanceOpen(true);
                        }}
                        className={classes.dropdownItem}
                        style={{ cursor: "pointer" }}
                      >
                        Balance Brought Forward
                      </span>

                      <NavLink
                        to="/reports/generalledger"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Journal Entries
                      </NavLink>
                      <NavLink
                        to="/accounting/journalentry/journal-search"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Journal Search
                      </NavLink>
                      <NavLink
                        to="/accounting/banksreconcillation"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Reconciliation
                      </NavLink>

                      <NavLink
                        to="/accounting/bankstatement"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Bank Statement
                      </NavLink>
                      {/* <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Cash Management</span>
                        <div className={classes.submenu}> */}
                      {/* <NavLink to="/transactions/sales-invoice/sale" onClick={() => setOpenDropdown(null)}>
                            Sales
                          </NavLink> */}
                      {/* <NavLink to="/accounting/cashmanage/cashReciept" onClick={() => setOpenDropdown(null)}>
                            Cash Reciept
                          </NavLink>


                        </div>
                      </div> */}
                      {/* <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Depreciation
                      </NavLink> */}

                      {/*    <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Trial balance
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Balance Sheet
                      </NavLink> */}
                    </>
                  )}
                </div>
              )}
            </div>
          ) : (
            <Link to={item.path} key={item.label} className={classes.link}>
              <div className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}>
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>
            </Link>
          );
        })}
        <UploadSalaryModal isOpen={showUploadModal} onClose={() => setShowUploadModal(false)} />
        <UploadAllowanceModal isOpen={showUploadAllowanceModal} onClose={() => setShowUploadAllowanceModal(false)} />
      </div>

      {/* User section */}
      <div className={classes.user}>
        <img src={usrnoti} className={classes.bellnoti} alt="Notification" />
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
            </p>
          </div>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user?.name || 'User'}</p>
                <p className={classes.userEmail}>{user?.email || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              {companyList && companyList.length > 0 && (
                <div
                  className={classes.dropdownItemWithSub}
                  onMouseEnter={openCompanySwitcher}
                  onMouseLeave={scheduleCloseCompanySwitcher}
                >
                  <span className={classes.dropdownItemLabel}>
                    <img src={stngs} alt="Switch" className={classes.dropdownIcon} />
                    Switch Account
                  </span>
                  {companySwitcherOpen && (
                    <div
                      className={`${classes.submenu} ${classes.submenuUser}`}
                      onMouseEnter={openCompanySwitcher}
                      onMouseLeave={scheduleCloseCompanySwitcher}
                    >
                      {companyList.map((c) => {
                        const id = c?.id || c?.company_id || c?.companyId || c.id;
                        const switchCompany = (company) => {
                          try {
                            const cid = company?.id || company?.company_id || company?.companyId || null;
                            if (cid) {
                              try { localStorage.setItem('company_id', String(cid)); } catch (e) { }
                              try { localStorage.setItem('companyInfo', JSON.stringify(company)); } catch (e) { }
                            }
                            // clear react-query cache if available
                            try {
                              const qc = window.__REACT_QUERY_QUERY_CLIENT__ || null;
                              if (qc && typeof qc.clear === 'function') qc.clear();
                              if (qc && typeof qc.invalidateQueries === 'function') qc.invalidateQueries();
                            } catch (e) { }

                            if (typeof setActiveCompany === 'function') setActiveCompany(id, company);
                            if (typeof updateUser === 'function' && user) {
                              const updatedUser = { ...user, company: company, company_id: String(id) };
                              updateUser(updatedUser);
                            }
                          } catch (e) {
                            console.error('switchCompany failed', e);
                          }
                        };

                        return (
                          <NavLink
                            to="/dashboard"
                            key={id}
                            className={({ isActive }) => `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`}
                            onClick={() => {
                              switchCompany(c);
                              setUserDropdownOpen(false);
                              navigate('/dashboard');
                            }}
                          >
                            {c?.name}
                          </NavLink>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setUserDropdownOpen(false);
                  navigate('/settings/organization');
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Organization Settings
              </button>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowInviteUserModal(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Invite" className={classes.dropdownIcon} />
                Invite user
              </button>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  navigate('/settings/add-company');
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Add Company
              </button>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowChangePassword(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Password
              </button>

              <button
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  handleLogout();
                  setUserDropdownOpen(false);
                  // Redirect to signin page after logout
                  // window.location.href = "/login";
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
      {showChangePassword && (
        <ChangePassword onClose={() => setShowChangePassword(false)} />
      )}
      <InviteUserModal show={showInviteUserModal} onHide={() => setShowInviteUserModal(false)} />
      <Balance isOpen={isBalanceOpen} onClose={() => setIsBalanceOpen(false)} />

    </div>
  );
}
